// Copyright (c) 2019 Deere & Company

import * as busyCounter from '../action-creators/busy-counter';
import {getFileName} from './get-file-name';
import {getSmartForm} from '../repositories';
import {getStore} from '../../store-factory';
import {openFile} from './open-file';

export const downloadSmartForm = async(formName, objectId) => {

    const {dispatch, getState} = getStore();

    dispatch(busyCounter.increaseBusyCounter());
    try {

        const response = await getSmartForm(formName, objectId, getState().user.details.settings.language.primaryLanguage.key);

        const fileName = getFileName(response);

        const blob = await response.blob();

        openFile(blob, fileName, 'application/pdf');

    } catch (error) {

    } finally {

        dispatch(busyCounter.decreaseBusyCounter());

    }

};



// WEBPACK FOOTER //
// ./src/shared/services/download-smart-form.js